import './assets/css/global.css'
import './assets/css/styles.css'
import Header from './components/Header';
import Home from './components/Home';
import Intro from './components/Intro';
import Main from './components/Main';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <Home />
      <Intro />
      <Main />
      <Footer />
    </>
  );
}

export default App;
